export default __webpack_public_path__ + "static/media/niot-litepaper.25362fb1.png";